import { Form } from '@anytag/shared-atoms';
import { useTranslation } from 'react-i18next';
import { InternalMemoField } from '../../shared';

export const InfluencerMemoSection = () => {
  const { t } = useTranslation();

  return (
    <>
      <Form.SectionTitle className="mt-3 mb-0" label={t('Internal memo')} />
      <InternalMemoField />
    </>
  );
};
